import { useMemo, memo } from 'react';
import { useTranslation } from '@frontend/i18n';
import { INSURANCE_STATUS_MAPPING } from '../utils/constants';
import { InsuranceStatusChip } from './insurance-status-chip';
import { InsuranceStatusChipButton } from './insurance-status-chip-button';

type InsuranceStatusProps = {
  enhancedVerificationInprogress: boolean;
  coverageStatus?: string;
  hasErrors: boolean;
  locationId: string;
  onVerifyClick: () => void;
};
export const InsuranceStatus = memo(
  ({ enhancedVerificationInprogress, coverageStatus, hasErrors, locationId, onVerifyClick }: InsuranceStatusProps) => {
    const { t } = useTranslation('insuranceDetails');

    const statusInfo = useMemo(() => {
      return INSURANCE_STATUS_MAPPING.get(coverageStatus || '');
    }, [coverageStatus]);

    if (enhancedVerificationInprogress) {
      return (
        <InsuranceStatusChip
          statusInfo={{
            text: t('Processing'),
            variant: 'warn',
            iconName: 'insurance-investigate',
          }}
        />
      );
    }

    if (statusInfo) {
      return <InsuranceStatusChip statusInfo={statusInfo} />;
    }

    return (
      <InsuranceStatusChipButton
        insuranceCoverageStatus={coverageStatus}
        hasErrors={hasErrors}
        locationId={locationId}
        onClick={onVerifyClick}
        shouldShowVerifyButton={false}
      />
    );
  }
);

InsuranceStatus.displayName = 'InsuranceStatus';
